module.exports = __webpack_public_path__ + "static/media/seating_rows.4fbbf759.svg";